var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","pb-1":""}},[_c('div',{ref:"plotContainer",staticClass:"plot-container"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }